import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getEngagementRowStyles = props => {
  var itemsToBeShownInRow = props.itemsToBeShownInRow,
    height = props.height;
  var _tokens$spacing = tokens.spacing,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_8 = _tokens$spacing.SPACING_8;
  return StyleSheet.create({
    row: {
      flexDirection: 'row',
      width: '100%',
      paddingTop: SPACING_12,
      alignItems: 'stretch',
      height: height
    },
    cardWrapper: {
      width: 100 / itemsToBeShownInRow + "%",
      paddingHorizontal: SPACING_8,
      height: '100%'
    }
  });
};